import {isApiResponseBodyError, isFetchBaseQueryError} from './apiUtils';

export const getTextMatchNormalizedMatcher = (value: string) => {
  return value
    ? RegExp(
        value
          .normalize('NFD')
          .replace(/\p{Diacritic}/gu, '')
          .replace(/[^a-zA-Z0-9<>]/g, ' ')
          .trim()
          .replace(/(?<=\S)(\S)/g, '\\s*$1'),
        'ig',
      )
    : null;
};

export const getTextMatchNormalizedText = (value: string) => {
  return value
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .replace(/[^a-zA-Z0-9<>]/g, ' ');
};

export const emailRegExp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

export const isMobile = () =>
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

export const isLandscape = () => window.matchMedia('(orientation: landscape)').matches;

export const isPortrait = () => window.matchMedia('(orientation: portrait)').matches;

export const getErrorMessage = (e: unknown) => {
  let message = 'An error occurred.';

  if (e instanceof Error) {
    message = e.message;
  } else if (isFetchBaseQueryError(e)) {
    if ('data' in e && isApiResponseBodyError(e.data)) {
      message = e.data.message;
    } else if ('error' in e) {
      message = e.error;
    }
  } else if (typeof e === 'string') {
    message = e;
  } else {
    message = JSON.stringify(e);
  }

  return message;
};

export const copyToClipboard = (text: string) => {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(text).catch((err) => {
      console.error('Failed to copy: ', err);
    });
  } else {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.opacity = '0';
    textArea.style.pointerEvents = 'none';
    textArea.style.position = 'fixed';
    textArea.style.zIndex = '-1';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand('copy');
    } catch (err) {
      console.error('Failed to copy: ', err);
    } finally {
      document.body.removeChild(textArea);
    }
  }
};
